module.exports = "<header ui-view=header></header> <main ngf-drop ng-model=draggedFiles ngf-drag-over-class=dragover ngf-multiple=false ngf-allow-dir=false ngf-accept=\"'.json,.yaml,.yml'\"> <div ui-layout=\"{ flow : 'column', dividerSize: '8px'}\"> <div class=\"editor pane\" ui-layout-container> <div ui-view=editor></div> </div> <div class=\"preview pane\" ui-layout-container> <div ui-view=preview></div> </div> </div> <div ng-if=showAbout ng-include=\"'templates/intro.html'\"></div> <div class=file-drag> <div class=dash> <p>Drop your file here</p> </div> </div> </main> ";


//////////////////
// WEBPACK FOOTER
// ./views/main.html
// module id = 277
// module chunks = 0